import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-papi-types';
import { EditorState } from '@wix/da-editor-tiptap/pkg/components/Editor/types';
import { CommissionStatusType } from '../../types/commissions';
import { SubmittingState } from './types';
import { EditorFeature } from '@wix/da-editor-tiptap/pkg/server/features/types';

export type CreateCommissionPayload = {
  title: string;
  pointsCost: number;
  editorRawState?: EditorState;
  editorContent?: any;
  features?: EditorFeature[];
  coverImageDeviationId?: number;
};

export type ChangeCommissionStatusPayload = {
  deviation: PapiDeviation;
  status: CommissionStatusType;
};

export type UpdateCommissionPayload = Omit<CreateCommissionPayload, 'title' | 'pointsCost'> & {
  title?: string;
  pointsCost?: number;
  commissionid: number;
  redirectOnSuccess?: boolean;
  onSuccess?: (deviation: PapiDeviation) => void;
  onError?: () => void;
};

export type FetchCommissionPayload = {
  deviationId: number;
  username: string;
  onSuccess?: (deviation: PapiDeviation) => void;
};

export const openCommissionEditModal = createAction(
  '@@COMMISSIONS.OPEN_EDIT_MODAL',
  (params: any) => ({ params })
);

export const createCommission = createAction(
  '@@COMMISSIONS.CREATE',
  (payload: CreateCommissionPayload) => payload
);

export const updateCommission = createAction(
  '@@COMMISSION.UPDATE',
  (payload: UpdateCommissionPayload) => payload
);

export const changeCommissionStatus = createAction(
  '@@COMMISSION.CHANGE_STATUS',
  (payload: ChangeCommissionStatusPayload) => payload
);

export const changeCommissionStatusSuccess = createAction(
  '@@COMMISSION.CHANGE_STATUS_SUCCESS',
  (payload: PapiDeviation) => payload
);

export const toggleCommissionStatus = createAction(
  '@@COMMISSION.TOGGLE_STATUS',
  (payload: PapiDeviation) => payload
);

export const updateSubmittingState = createAction(
  '@@COMMISSION.UPDATE_SUBMITTING_STATE',
  ({ submittingState }: { submittingState: SubmittingState }) => ({
    submittingState,
  })
);

export const updateSubmitErrorString = createAction(
  '@@COMMISSION.UPDATE_SUBMIT_ERROR_STRING',
  ({ submitErrorString }: { submitErrorString: string }) => ({
    submitErrorString,
  })
);

export const fetchCommission = createAction(
  '@@COMMISSION.FETCH',
  (payload: FetchCommissionPayload) => payload
);
